var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * 拼接 restful url,例如：
 * input: (url='/person/:person_id/update', data={person_id: 1, name: 'foo', age: 'bar'}
 * output: url='/person/1/update', data={name: 'foo', age: 'bar'}
 */
export var restfulTransformInterceptor = function (conf) {
    var url = conf.url, params = conf.params, method = conf.method, data = conf.data;
    var _url = url || '';
    var _method = method || '';
    var _data = ['get', 'delete'].indexOf(_method) >= 0 ? __assign({}, params) : __assign({}, data);
    _url = Object.keys(_data).reduce(function (r, k) {
        if (_data[k] === undefined ||
            _data[k] === null ||
            (typeof (_data[k]) !== 'string' && typeof (_data[k]) !== 'number')) {
            return r;
        }
        var reg = new RegExp(":".concat(k), 'g');
        if (!r.match(reg)) {
            return r;
        }
        // remove k
        var val = _data[k];
        delete _data[k];
        return r.replace(reg, "".concat(val));
    }, _url);
    var _conf = __assign({}, conf);
    _conf.url = _url;
    if (['get', 'delete'].indexOf(_method) >= 0) {
        _conf.params = _data;
    }
    else {
        _conf.data = _data;
    }
    return _conf;
};
//# sourceMappingURL=restful-transform.js.map